<footer class="footer">
  <div class="footer-content">
    <div class="clearfix">
      <span class="mentions"> Développé par </span>
      <img class="logo" [src]="'assets/hubgrade/veolia-brand.png'" />
    </div>
  </div>
</footer>
